import React, { Component } from "react";
import UsersChart from "./UsersChart";
import AssetChart from "./AssetChart";
import IncidentCustomers from "./IncidentCustomers";
import SDWanAlarms from "./SDWanAlarms";
import SDWanAssets from "./SDWanAssets";
import SDWanHealth from "./SDWanHealth";
import SDWanServices from "./SDWanServices";
import Select from "react-select";
import { EnterpriseData } from "../EnterpriseData";

export default class EnterpriseNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adHocData: {
        brand: null,
      },
      allBrandList: [
        { id: 1, name: "Select All" },
        { id: 2, name: "Cust1" },
        { id: 3, name: "Cust2" },
        { id: 4, name: "Cust3" },
        { id: 5, name: "Cust4" },
      ],
      errors: {},
      isValid: true,
      options: [
        { value: 1, label: "Cust1" },
        { value: 2, label: "Cust2" },
        { value: 3, label: "Cust3" },
        { value: 4, label: "Cust4" },
        { value: 5, label: "Cust5" },
        { value: 6, label: "Cust6" },
        { value: 7, label: "Cust7" },
        { value: 8, label: "Cust8" },
        { value: 9, label: "Cust9" },
      ],
      selectedCustomer: [
        { value: 1, label: "Cust1" },
        { value: 2, label: "Cust2" },
        { value: 3, label: "Cust3" },
        { value: 4, label: "Cust4" },
        { value: 5, label: "Cust5" },
        { value: 6, label: "Cust6" },
        { value: 7, label: "Cust7" },
        { value: 8, label: "Cust8" },
        { value: 9, label: "Cust9" },
      ],
      selectedCustomerData: EnterpriseData,
      message: "",
      assetCategories: [],
      assetSeries: [],
      usersCategories: [],
      usersSeries: [],
      incidentCategories: [],
      incidentSeries: [],
    };
  }

  componentDidMount() {
    this.fetchCustomerData();
  }

  handleSelect = (event) => {
    if (event.length === 0) {
      // If no options are selected, retain the previous state to ensure at least one option
      console.log("At least one customer must be selected.");
      return;
    }

    // if (event.length <= 1) {
    //   console.log("first");
    // } else {
    this.setState(
      {
        selectedCustomer: event,
      },
      () => {
        this.fetchCustomerData();
      }
    );
    // }
  };

  fetchCustomerData = () => {
    const filteredArray = EnterpriseData.filter((obj) =>
      this.state.selectedCustomer.some(
        (filterObj) => filterObj.value === obj.id
      )
    );

    let data = filteredArray.some((obj) => obj.id === 1);

    if (data) {
      this.setState({
        message: "Data found",
      });
    } else {
      this.setState({
        message: "No Data",
      });
    }

    const extractedAssetData = filteredArray
      .filter((item) => item.assets !== undefined) // Filter out customers without assets property
      .map((item) => ({
        customerName: item.customerName,
        assets: item.assets,
      }))
      .sort((a, b) => b.assets - a.assets); // Sort by assets in descending order

    // Prepare the data for series and categories
    const assetSeries = [
      {
        name: "Assets",
        data: extractedAssetData.map((item) => item.assets),
      },
    ];

    const assetCategories = extractedAssetData.map((item) => item.customerName);

    const extractedUsersData = filteredArray
      .filter((item) => item.users !== undefined) // Filter out customers without users property
      .map((item) => ({
        customerName: item.customerName,
        users: item.users,
      }))
      .sort((a, b) => b.users - a.users); // Sort by users in descending order

    // Prepare the data for series and categories
    const usersSeries = [
      {
        name: "Users",
        data: extractedUsersData.map((item) => item.users),
      },
    ];

    const usersCategories = extractedUsersData.map((item) => item.customerName);

    const incidentCategories = [];
    const incidentSeries = [
      { name: "Canceled", data: [] },
      { name: "Closed", data: [] },
      { name: "In Progress", data: [] },
      { name: "New", data: [] },
      { name: "On Hold", data: [] },
    ];

    filteredArray.forEach((enterprise) => {
      if (
        enterprise.incidents &&
        Object.keys(enterprise.incidents).length > 0
      ) {
        // Add the customer name to incidentCategories
        incidentCategories.push(enterprise.customerName);

        // Add respective incident data to the incidentSeries
        incidentSeries[0].data.push(enterprise.incidents.canceled);
        incidentSeries[1].data.push(enterprise.incidents.closed);
        incidentSeries[2].data.push(enterprise.incidents.inProgress);
        incidentSeries[3].data.push(enterprise.incidents.new);
        incidentSeries[4].data.push(enterprise.incidents.onHold);
      }
    });

    // incidentSeries.map((series) => {
    //   return {
    //     name: series.name,
    //     data: series.data.map((value) => (value == 117 ? null : value)),
    //   };
    // });

    this.setState({
      selectedCustomerData: filteredArray,
      assetSeries,
      assetCategories,
      usersSeries,
      usersCategories,
      incidentCategories,
      incidentSeries,
    });
  };

  render() {
    return (
      <>
        <div
          className="row mb-2 mx-3 align-items-center justify-content-between"
          style={{ margin: "auto" }}
        >
          {/* <div className="col-md-10">
            <div className="d-flex">
              {this.state.allBrandList.map((brand, index) => {
                return (
                  <>
                    <button
                      key={index}
                      className="mx-1 btn btn-info"
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        text: "white",
                        backgroundColor: "#29558D",
                        padding: "5px 20px",
                      }}
                      onClick={() => this.handleSelect(brand)}
                    >
                      {brand.name}
                    </button>
                  </>
                );
              })}
            </div>
          </div> */}

          <div className="" style={{ width: "25rem" }}>
            <Select
              defaultValue={this.state.options}
              options={this.state.options}
              onChange={this.handleSelect}
              isMulti={true}
              isClearable={false}
            />
          </div>
          <div
            style={{
              color: "#27538C",
              fontSize: "2.2rem",
              fontWeight: "600",
              letterSpacing: "0.2px",
            }}
          >
            CogNeo
          </div>
        </div>

        <div className="row" style={{ margin: "auto" }}>
          {/* -------------------network----------------------------- */}
          <div className="col-md-5" style={{ paddingRight: "0px" }}>
            <div className="px-4 py-1 rounded bg-primary text-white">
              Network
            </div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Domains
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/domain.png"}
                          height={30}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.4rem", fontWeight: 500 }}
                      >
                        8
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    OEMs
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/topology.png"}
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        13
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Critical Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/redwarning.jpg"
                          }
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        567
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-7">
            {/* ------------------------------AI Engine------------------------------ */}
            <div className="px-4 py-1 rounded bg-primary text-white">
              AI Engine
            </div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    AI Correlated Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/aicorrelatedalarms.png"
                          }
                          height={25}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        {
                          this.state.selectedCustomerData[0].predictive
                            .aiCorrelated
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Predicted Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/success.jpg"}
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        {
                          this.state?.selectedCustomerData[0].predictive
                            .predictiveIncidents
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Prediction Coverage
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/predictioncoverage.png"
                          }
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        {
                          this.state?.selectedCustomerData[0].predictive
                            .coverage
                        }
                        %
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Prediction Accuracy
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/predictionaccuracy.png"
                          }
                          height={25}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        {
                          this.state?.selectedCustomerData[0].predictive
                            .accuracy
                        }
                        %
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ margin: "auto" }}>
          {/* -------------------network----------------------------- */}
          <div className="col-md-8" style={{ paddingRight: "0px" }}>
            <div className="px-4 py-1 rounded bg-primary text-white">
              Automation
            </div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border" style={{ height: "7rem" }}>
                  <div
                    className="bg-info text-white py-2"
                    style={{
                      // height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                    }}
                  >
                    Open Incidents
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/warning1.png"}
                          height={30}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.4rem", fontWeight: 500 }}
                      >
                        2883
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border" style={{ height: "7rem" }}>
                  <div
                    className="bg-info text-white py-2"
                    style={{
                      // height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                    }}
                  >
                    P1 SLA
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/handshake.png"}
                          height={30}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        99.46%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "3", margin: "0 0.2%" }}>
                <div className="card border" style={{ height: "7rem" }}>
                  <div
                    className="bg-info text-white py-2"
                    style={{
                      // height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                    }}
                  >
                    Pipelines
                  </div>

                  <div className="card-body" style={{ padding: "0.3rem" }}>
                    <div className="d-flex justify-content-between">
                      {/* First group - Success */}
                      <div
                        className="d-flex align-items-center"
                        style={{ width: "33%" }}
                      >
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/greenCircle.png"
                            }
                            height={20}
                          />
                        </div>
                        <div
                          className="d-flex flex-column align-items-start"
                          style={{ marginLeft: "1rem" }}
                        >
                          <p
                            className="card-title mb-0"
                            style={{
                              fontSize: "1.3rem",
                              fontWeight: 500,
                            }}
                          >
                            {
                              this.state?.selectedCustomerData[0].nap
                                .executionSuccess
                            }
                          </p>
                          <p
                            className="card-text"
                            style={{
                              fontSize: "0.9rem",
                              fontWeight: 400,
                              marginTop: "0.2rem",
                            }}
                          >
                            Success
                          </p>
                        </div>
                      </div>

                      {/* Second group - Failed */}
                      <div
                        className="d-flex align-items-center"
                        style={{ width: "33%" }}
                      >
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/redCircle.png"
                            }
                            height={20}
                          />
                        </div>
                        <div
                          className="d-flex flex-column align-items-start"
                          style={{ marginLeft: "1rem" }}
                        >
                          <p
                            className="card-title mb-0"
                            style={{
                              fontSize: "1.3rem",
                              fontWeight: 500,
                            }}
                          >
                            {
                              this.state?.selectedCustomerData[0].nap
                                .executionFailure
                            }
                          </p>
                          <p
                            className="card-text"
                            style={{
                              fontSize: "0.9rem",
                              fontWeight: 400,
                              marginTop: "0.2rem",
                            }}
                          >
                            Failed
                          </p>
                        </div>
                      </div>

                      {/* Third group - Pending */}
                      <div
                        className="d-flex align-items-center"
                        style={{ width: "33%" }}
                      >
                        <div>
                          <img
                            src={process.env.PUBLIC_URL + "/images/warning.jpg"}
                            height={20}
                          />
                        </div>
                        <div
                          className="d-flex flex-column align-items-start"
                          style={{ marginLeft: "1rem" }}
                        >
                          <p
                            className="card-title mb-0"
                            style={{
                              fontSize: "1.3rem",
                              fontWeight: 500,
                            }}
                          >
                            {
                              this.state?.selectedCustomerData[0].nap
                                .executionPartialSuccess
                            }
                          </p>
                          <p
                            className="card-text"
                            style={{
                              fontSize: "0.9rem",
                              fontWeight: 400,
                              marginTop: "0.2rem",
                            }}
                          >
                            Partial Success
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            {/* ------------------------------AI Engine------------------------------ */}
            <div className="px-4 py-1 rounded bg-primary text-white">SDx</div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border" style={{ height: "7rem" }}>
                  <div
                    className="bg-info text-white py-2"
                    style={{
                      // height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                    }}
                  >
                    SD-LAN
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/peer-to-peer.png"
                          }
                          height={25}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        319
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border" style={{ height: "7rem" }}>
                  <div
                    className="bg-info text-white py-2"
                    style={{
                      // height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                    }}
                  >
                    SD-WAN
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/domains.png"}
                          height={30}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        2393
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-3 mb-2">
          <div
            className="d-flex p-1"
            style={{ fontSize: "medium", fontWeight: 400, color: "black" }}
          >
            Incident By Customers
          </div>
          <div>
            <IncidentCustomers
              incidentSeries={this.state.incidentSeries}
              incidentCategories={this.state.incidentCategories}
            />
          </div>
        </div>

        <div className="card mx-3 mb-2">
          <div
            className="d-flex p-1"
            style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
          >
            Users By Customers
          </div>
          <div>
            <UsersChart
              usersSeries={this.state.usersSeries}
              usersCategories={this.state.usersCategories}
            />
          </div>
        </div>

        <div className="card mx-3 mb-2">
          <div
            className="d-flex p-1"
            style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
          >
            Asset By Customers
          </div>
          <div>
            <AssetChart
              assetData={this.state.selectedCustomerData}
              assetSeries={this.state.assetSeries}
              assetCategories={this.state.assetCategories}
            />
          </div>
        </div>

        <div>
          <div className="px-4 py-2 rounded bg-primary text-white mx-3 mb-2">
            SD - WAN (Versa)
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
            >
              SD-Wan Alarms
            </div>
            <div>
              <SDWanAlarms message={this.state.message} />
            </div>
          </div>

          <div className="row mx-3 mb-2">
            <div className="card col-md-6">
              <div
                className="d-flex py-1"
                style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
              >
                SD-Wan Assets
              </div>
              <div>
                <SDWanAssets message={this.state.message} />
              </div>
            </div>

            <div className="card col-md-6">
              <div
                className="d-flex py-1"
                style={{ fontSize: "Medium", fontWeight: 500, color: "black" }}
              >
                SD-Wan Hardware
              </div>

              <div className="d-flex flex-wrap">
                <div className="card col-12 my-3">
                  <div className="row align-items-center">
                    <div
                      className="col-12"
                      style={{ fontSize: "1.4rem", fontWeight: 300 }}
                    >
                      No of CPU
                    </div>
                    <div
                      className="col-12"
                      style={{
                        fontSize: "1.8rem",
                        fontWeight: 400,
                        color: "#27538C",
                      }}
                    >
                      6
                    </div>
                  </div>
                </div>

                <div className="card col-12">
                  <div className="row align-items-center">
                    <div
                      className="col-12"
                      style={{ fontSize: "1.4rem", fontWeight: 300 }}
                    >
                      Software Version
                    </div>
                    <div
                      className="col-12"
                      style={{
                        fontSize: "1.8rem",
                        fontWeight: 400,
                        color: "#27538C",
                      }}
                    >
                      20.2.1 - GA 47E18E0 20200213
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
            >
              SD-WAN Health Summary
            </div>
            <div>
              <SDWanHealth message={this.state.message} />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "medium", fontWeight: 500, color: "black" }}
            >
              SD-WAN Services
            </div>
            <div>
              <SDWanServices message={this.state.message} />
            </div>
          </div>
        </div>
      </>
    );
  }
}
